/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerProjectDto
 */
export interface BorrowerProjectDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerProjectDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerProjectDto
     */
    folderIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerProjectDto
     */
    projectTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerProjectDto
     */
    insuranceProjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerProjectDto
     */
    statusId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerProjectDto
     */
    projectStartDate?: string;
}

/**
 * Check if a given object implements the BorrowerProjectDto interface.
 */
export function instanceOfBorrowerProjectDto(value: object): value is BorrowerProjectDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('folderIdentifier' in value) || value['folderIdentifier'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    return true;
}

export function BorrowerProjectDtoFromJSON(json: any): BorrowerProjectDto {
    return BorrowerProjectDtoFromJSONTyped(json, false);
}

export function BorrowerProjectDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerProjectDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'folderIdentifier': json['folderIdentifier'],
        'projectTypeId': json['projectTypeId'] == null ? undefined : json['projectTypeId'],
        'insuranceProjectId': json['insuranceProjectId'] == null ? undefined : json['insuranceProjectId'],
        'statusId': json['statusId'],
        'projectStartDate': json['projectStartDate'] == null ? undefined : json['projectStartDate'],
    };
}

export function BorrowerProjectDtoToJSON(json: any): BorrowerProjectDto {
    return BorrowerProjectDtoToJSONTyped(json, false);
}

export function BorrowerProjectDtoToJSONTyped(value?: BorrowerProjectDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'folderIdentifier': value['folderIdentifier'],
        'projectTypeId': value['projectTypeId'],
        'insuranceProjectId': value['insuranceProjectId'],
        'statusId': value['statusId'],
        'projectStartDate': value['projectStartDate'],
    };
}

